import styled from 'styled-components';

import { Help } from 'ui/icons';
import { PopoverTrigger } from 'ui/popover';
import { colors, spacing } from 'ui/theme';

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};

  align-self: stretch;
`;

export const HelpPopoverTrigger = styled(PopoverTrigger)`
  display: flex;
`;

export const HelpPopoverIcon = styled(Help)`
  color: ${colors.secondaryText};
`;
